import { useState } from "react";
import { useSelector } from "react-redux";
import { Card, Button, Table } from "react-bootstrap";
import { useUpdateQuestionMutation } from "../../slices/fun_stuff/quizAdminSlice";
import { useLoadQuestionFeedback } from "../../hooks/useLoadQuestionFeedback";
import Question from "./Question";
import UpdateQuestionForm from "./UpdateQuestionForm";
import Loader from "../Loader";
import { toast } from "react-toastify";

const QuestionReview = (() => {
    const [showQuestion, setShowQuestion] = useState({});
    const [showUpdateForm, setShowUpdateForm] = useState({});
    const [updatedQuestion, setUpdatedQuestion] = useState({
        question: '',
        options: [],
        correct_answer: '',
        explanation: '',
        id: 0,
    })

    const { questionFeedback } = useSelector(state => state.quizAuth);
    const { loadQuestionFeedback, isLoading } = useLoadQuestionFeedback();
    const [updateQuestion] = useUpdateQuestionMutation();

    function handleUpdateClick(question, index) {
        setShowUpdateForm({ ...showUpdateForm, [index]: !showUpdateForm[index]});
        setUpdatedQuestion(question);
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (!updatedQuestion.options.includes(updatedQuestion.correct_answer)) {
            window.alert("Correct answer must be one of the options.");
            return;
        }

        try {
            await updateQuestion({
                question: updatedQuestion.question,
                options: updatedQuestion.options,
                correct_answer: updatedQuestion.correct_answer,
                explanation: updatedQuestion.explanation,
                id: updatedQuestion.id,
            });
            toast.success("Question updated");
            await loadQuestionFeedback();
            setShowUpdateForm({});
            setShowQuestion({});
        } catch (error) {
            window.alert("Error updating question", error?.data?.message || error.error);
        }
    }
    
    if (!questionFeedback || isLoading) return <Loader />
    return (
    <Card className="my-3 shadow-sm">
        <Card.Header className="shadow-sm card-header-dark">Question Feedback</Card.Header>
        <Card className="m-3 shadow-sm">
            <Card.Header>Need Review</Card.Header>
            <Card.Body>
            {questionFeedback.unresolved.map((entry, index) => (
            <Card key={`show-question-${index}`}>
                <Button className="quiz-btn-dark" onClick={() => {
                    setShowQuestion({ ...showQuestion, [index]: !showQuestion[index] });
                    setShowUpdateForm({})}
                    }>
                        {`${new Date(entry.created_at).toLocaleDateString()} - ${entry.formatted_topic.replaceAll('_', ' ')}`}
                    </Button>

                {showQuestion[index] &&
                <div className="d-flex flex-column justify-content-center align-items-center my-3">
                    <strong className="fs-4 m-4">{entry.report}</strong>
                    <p className="mx-4 my-0">{`Reported by: ${entry.reported_by}`}</p>
                    <Question 
                        question={entry.question} 
                        index={index}
                        active={false}
                        showAnswers={true} 
                    />

                    <Button className="m-4 quiz-btn w-50" onClick={() => handleUpdateClick(entry.question, index)}>{showUpdateForm[index] ? 'Hide update form' : 'Show update form'}</Button>
                    
                {showUpdateForm[index] &&
                <UpdateQuestionForm 
                    updatedQuestion={updatedQuestion}
                    setUpdatedQuestion={setUpdatedQuestion}
                    handleSubmit={handleSubmit} 
                />}
                
                </div>}
            </Card>
            ))}
            </Card.Body>
        </Card>

        <Card className="m-3 shadow-sm">
            <Card.Header>
                <h5 className="mb-0">Completed Reviews (Last 30 Days)</h5>
            </Card.Header>
            <Card.Body >
                {questionFeedback.resolved.length === 0 ? (
                <Card.Text>No completed reviews found.</Card.Text>
                ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                        <th>Topic</th>
                        <th>Report</th>
                        <th>Reported By</th>
                        <th>Reviewed By</th>
                        <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {questionFeedback.resolved.map((review) => (
                        <tr key={review.report_id}>
                            <td>{review.formatted_topic.replaceAll("_", " ")}</td>
                            <td>{review.report}</td>
                            <td>{review.reported_by}</td>
                            <td>{review.reviewed_by}</td>
                            <td>{new Date(review.created_at).toLocaleDateString()}</td>
                        </tr>
                        ))}
                    </tbody>
                </Table>
                )}
            </Card.Body>
        </Card>
    </Card>
    );
})

export default QuestionReview